import React, { useState } from 'react';
import axios from 'axios';
import { Image, Plus, Trash2, ImageOff } from 'lucide-react';
import { resolveFileUrl } from '../../utils/fileUrl';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PhotoItem = ({ photo, index, url, onImageClick, interventionId, onRefresh }) => {
  const [broken, setBroken] = useState(false);

  if (broken) {
    return (
      <div className="photo-item border border-[#27272A] relative group flex items-center justify-center bg-[#1A1A1A] min-h-[100px]">
        <div className="flex flex-col items-center gap-1 p-4">
          <ImageOff className="w-6 h-6 text-[#71717A]" />
          <p className="text-[#52525B] text-[10px]">Non disponibile</p>
        </div>
        <div className="absolute inset-0 bg-black/70 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
          <button
            onClick={async (e) => {
              e.stopPropagation();
              if (!window.confirm('Sei sicuro di voler eliminare questa foto?')) return;
              try {
                await axios.delete(`${API_URL}/api/interventions/${interventionId}/photos/${index}`, { withCredentials: true });
                onRefresh();
              } catch { /* noop */ }
            }}
            className="p-2 bg-[#EF4444] text-white rounded-none hover:bg-[#DC2626]"
            title="Elimina"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className="photo-item border border-[#27272A] relative group"
      data-testid={`photo-${index}`}
    >
      <img
        src={url}
        alt={`Foto ${index + 1}`}
        onClick={() => onImageClick(url)}
        className="cursor-pointer"
        onError={() => setBroken(true)}
      />
      <div className="absolute inset-0 bg-black/70 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
        <a
          href={url}
          download={`foto_${index + 1}.jpg`}
          className="p-2 bg-[#009246] text-white rounded-none hover:bg-[#007a3a]"
          onClick={(e) => e.stopPropagation()}
          title="Scarica"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
        </a>
        <button
          onClick={async (e) => {
            e.stopPropagation();
            if (!window.confirm('Sei sicuro di voler eliminare questa foto?')) return;
            try {
              await axios.delete(`${API_URL}/api/interventions/${interventionId}/photos/${index}`, { withCredentials: true });
              onRefresh();
            } catch { /* noop */ }
          }}
          className="p-2 bg-[#EF4444] text-white rounded-none hover:bg-[#DC2626]"
          title="Elimina"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export const PhotoGallerySidebar = ({ interventionId, photos, onImageClick, onRefresh }) => (
  <div className="bg-[#121212] border border-[#27272A] p-6">
    <div className="flex items-center justify-between mb-4">
      <h3 className="text-lg font-semibold uppercase flex items-center gap-2" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
        <Image className="w-5 h-5 text-[#E3000F]" />
        Galleria Foto Intervento
      </h3>
      <label className="cursor-pointer">
        <input
          type="file"
          accept="image/*"
          className="hidden"
          onChange={async (e) => {
            const file = e.target.files?.[0];
            if (!file) return;
            const formData = new FormData();
            formData.append('file', file);
            try {
              await axios.post(`${API_URL}/api/interventions/${interventionId}/photos`, formData, {
                withCredentials: true,
                headers: { 'Content-Type': 'multipart/form-data' },
              });
              onRefresh();
            } catch {
              // Upload failed — user will see the photo didn't appear
            }
          }}
          data-testid="upload-photo-input"
        />
        <span className="bg-[#1A1A1A] border border-[#333333] hover:border-[#E3000F] text-white px-3 py-2 text-xs uppercase flex items-center gap-2 transition-colors">
          <Plus className="w-4 h-4" />
          Carica
        </span>
      </label>
    </div>
    {photos?.length > 0 ? (
      <div className="photo-grid">
        {photos.map((photo, index) => {
          const url = resolveFileUrl(photo.url);
          return (
            <PhotoItem
              key={photo.file_id || photo.url || `photo-${index}`}
              photo={photo}
              index={index}
              url={url}
              onImageClick={onImageClick}
              interventionId={interventionId}
              onRefresh={onRefresh}
            />
          );
        })}
      </div>
    ) : (
      <p className="text-[#71717A] text-center py-4">Nessuna foto</p>
    )}
  </div>
);
